export default __webpack_public_path__ + "static/media/5.be670a8d.jpeg";